export enum DrugSpecificProtocol {
  Hourly = 'Hourly',
  WeeklyCRS = 'WeeklyCrs',
  WeeklyInfection = 'WeeklyInfection',
  // Dummy protocols (created client side and not from db)
  SpecificTimesHourlyWithHospitalization = 'SpecificTimesHourlyWithHospitalization',
  SpecificTimesHourlyWithoutHospitalization = 'SpecificTimesHourlyWithoutHospitalization',
  WeeklyInfectionBiSpecific = 'WeeklyInfectionBiSpecific'
}

export enum DrugType {
  Bispecific = 'bispecific'
}

export interface DrugSpecificReportProtocolTemplate {
  id: number;
  type: DrugSpecificProtocol;
  timeBetweenReportsInMilliseconds: number;
  reportTimes: string[]; // example: ["08:00", "12:00", "16:00"]
  delayInHours: number;
  duration: number;
  durationUnitType: UnitType;
  endType: number;
  withHospitalization: boolean;
}

export interface DrugSpecific {
  id: number;
  name: string;
  drugType: DrugType;
  reportProtocolTemplates: DrugSpecificReportProtocolTemplate[];
}

export enum UnitType {
  Month = 'month',
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute'
}
